<template>
  <div class="back" @click="back">返回</div>
</template>

<script>
import { defineComponent } from "vue";
import { useRouter } from "vue-router";

export default defineComponent({
  setup() {
    const router = useRouter();

    const back = () => {
      router.back();
    };
    return {
      back,
    };
  },
});
</script>

<style lang="less" scoped>
.back {
  font-size: 20px;
  font-weight: bold;
}
</style>
